import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resolveDmpPurchaseReturnPath } from '@/components/DmpV2/purchaseReturnPath';
import { v2UiEnabled } from '@/components/DmpV2/features';
import useResize from '@/hooks/useResize';
import { Checkbox, FormControl, FormControlLabel, FormGroup, TextField } from '@mui/material';
import { LabelWrapper } from '@/components/Account/PreviewApplicationInfo/styled';
import TermsModal from '@/components/Account/RegisterForm/TermsModal';
import PageContainer from '@/components/Container/PageContainer';
import { Button } from '@/components/UI/Button';
import { H4 } from '@/components/UI/Typography/Heading';
import { Text } from '@/components/UI/Typography/Text';
import { Box, Flex, LoadingPage } from '@/layout';
import { updateAgreementsAcceptedAt } from '@/api/auth.api';
import { errorHandler } from '@/utils/toastHandler';

const TermsOfServiceUpdate = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isMobile } = useResize();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // 條款modal控制器
  const [checkBox, setCheckBox] = useState({
    infoCollect: false,
    terms: false,
  });

  const { infoCollect, terms } = checkBox;
  const handleChange = (value: string, current: boolean) => {
    setCheckBox({ ...checkBox, [value]: !current });
    handleClose(value);
  };

  const [open, setOpen] = useState({
    infoCollect: false,
    terms: false,
  });

  const handleClose = (key: string) => {
    setOpen({ ...open, [key]: false });
  };

  const handleOpen = (key: string) => {
    setOpen({ ...open, [key]: true });
  };

  const onSumbit = async () => {
    setIsLoading(true);
    try {
      const res = (
        await updateAgreementsAcceptedAt({
          tcAgreementAcceptedAt: 1,
          PICsAgreementAcceptedAt: 1,
        })
      ).data;
      if (res.success) {
        navigate((v2UiEnabled() ? resolveDmpPurchaseReturnPath(searchParams.get('path')) : null) || '/home');
      }
    } catch (error: any) {
      console.error(error);
      errorHandler(error.data?.message || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageContainer title={t('pages.termsUpdate.title')}>
      <LoadingPage isLoading={isLoading} />
      <TermsModal open={open} handleClose={handleClose} handleChange={handleChange} />

      <H4 fontWeight={'bold'}>{t('pages.termsUpdate.info-title')}</H4>
      <Text>{t('pages.termsUpdate.info')}</Text>

      <Box width={'fit-content'} backgroundColor={'#fff'} marginTop={60} padding={'40px'}>
        <H4 fontWeight={'bold'}>{t('pages.termsUpdate.requirement-title')}</H4>
        <Text>{t('pages.termsUpdate.requirement')}</Text>

        <FormControl sx={{ paddingTop: '30px' }} required component="fieldset">
          <FormGroup style={{ gap: '15px' }}>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{
                    color: '#999999',
                    '&.Mui-checked': {
                      color: '#999999',
                    },
                  }}
                  checked={infoCollect}
                  onChange={() => handleOpen('infoCollect')}
                  name="infoCollect"
                />
              }
              label={
                <LabelWrapper>
                  <Flex gridGap={isMobile ? '0' : '10px'} flexDirection={isMobile ? 'column' : 'row'}>
                    <span>{t('form.terms.label.pic.prev')}</span>
                    <span className="term">{t('form.terms.label.pic.last')}</span>
                  </Flex>
                </LabelWrapper>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  sx={{
                    color: '#999999',
                    '&.Mui-checked': {
                      color: '#999999',
                    },
                  }}
                  checked={terms}
                  onChange={() => handleOpen('terms')}
                  name="terms"
                />
              }
              label={
                <LabelWrapper>
                  <Flex gridGap={isMobile ? '0' : '10px'} flexDirection={isMobile ? 'column' : 'row'}>
                    <span>{t('form.terms.label.t&c.prev')}</span>
                    <span className="term">{t('form.terms.label.t&c.last')}</span>
                  </Flex>
                </LabelWrapper>
              }
            />
          </FormGroup>
        </FormControl>
        <Flex marginTop={30}>
          <Button
            size={'lg'}
            variant={'primary'}
            rounded={false}
            width={isMobile ? '100%' : 'unset'}
            disabled={!terms || !infoCollect}
            onClick={onSumbit}
          >
            {t('buttons.confirmAndContinue')}
          </Button>
        </Flex>
      </Box>
    </PageContainer>
  );
};

export default TermsOfServiceUpdate;
